import { formatDecimal } from "helpers";
import { RangeSliderProps } from "./types";
import { useCallback, useEffect, useRef, useState } from "react";

const RangeSlider: React.FC<RangeSliderProps> = (props) => {
  const {
    label,
    name,
    onChange,
    min,
    max,
    value,
    unit,
    step,
    formatAsDecimal = false,
  } = props;

  const refInput = useRef(null);
  const [currentPosition, setCurrentPosition] = useState<string>("");

  useEffect(() => {
    calculateCurrentPosition(refInput.current);
  }, []);

  const formatLabel = (label: string, value: number) => {
    let number = value.toString();
    if (formatAsDecimal) {
      number = formatDecimal(number.toString());
    }
    let result = label.replace("{value}", number).replace("{unit}", unit ?? "");

    return result;
  };

  const formatSelectedValue = (value: number) => {
    let number = value.toString();
    if (formatAsDecimal) {
      number = formatDecimal(number.toString());
    }

    return number;
  };

  const handleInputChanged = useCallback((e: any) => {
    calculateCurrentPosition(e.target);
    onChange(e, name);
  }, []);

  const calculateCurrentPosition = (range: any) => {
    const val = range.value;
    const min = range.min ? range.min : 0;
    const max = range.max ? range.max : 100;
    const newVal = Number(((val - min) * 100) / (max - min));
    setCurrentPosition(`${newVal}%`);
  };

  return (
    <div className="relative">
      <span className="text-sm text-gray-500 font-semibold dark:text-gray-400 absolute -top-4 right-0 ">
        {formatSelectedValue(value)} {unit}
      </span>
      <label htmlFor={name} className="absolute -top-9 block text-sm mb-2 font-medium leading-6 text-[#344054]">
        {label}
      </label>
      {/* https://9elements.github.io/fancy-border-radius/#65.84.100.0--40.635 */}
      {/* <div
        className="h-14 w-full  border  bg-blue-800 bg-opacity-10 overflow-hidden"
        // style={{ borderRadius: "100% 0% 100% 0% / 80% 100% 0% 20% " }}
      >
        <span
          className="mt-[-1px] h-14 bg-blue-500 bg-opacity-60 block"
          style={{ width: currentPosition }}
        ></span>
      </div> */}

      <input
        id={name}
        type="range"
        name={name}
        value={value}
        min={min}
        max={max}
        step={step}
        className="w-full bg-transparent cursor-pointer appearance-none disabled:opacity-50 disabled:pointer-events-none focus:outline-none
                    [&::-webkit-slider-thumb]:w-2.5
                    [&::-webkit-slider-thumb]:h-2.5
                    [&::-webkit-slider-thumb]:-mt-0.5
                    [&::-webkit-slider-thumb]:appearance-none
                    [&::-webkit-slider-thumb]:bg-white
                    [&::-webkit-slider-thumb]:shadow-[0_0_0_3px_rgba(125,88,213,1)]
                    [&::-webkit-slider-thumb]:rounded-full
                    [&::-webkit-slider-thumb]:transition-all
                    [&::-webkit-slider-thumb]:duration-150
                    [&::-webkit-slider-thumb]:ease-in-out
                    [&::-webkit-slider-thumb]:dark:bg-slate-700

                    [&::-range-progress]:h-52
                    [&::-range-progress]:border

                    [&::-moz-range-thumb]:w-2.5
                    [&::-moz-range-thumb]:h-2.5
                    [&::-moz-range-thumb]:appearance-none
                    [&::-moz-range-thumb]:bg-white
                    [&::-moz-range-thumb]:border-4
                    [&::-moz-range-thumb]:border-blue-600
                    [&::-moz-range-thumb]:rounded-full
                    [&::-moz-range-thumb]:transition-all
                    [&::-moz-range-thumb]:duration-150
                    [&::-moz-range-thumb]:ease-in-out

                    [&::-webkit-slider-runnable-track]:w-full
                    [&::-webkit-slider-runnable-track]:h-2
                    [&::-webkit-slider-runnable-track]:bg-gray-200
                    [&::-webkit-slider-runnable-track]:rounded-full
                    [&::-webkit-slider-runnable-track]:dark:bg-gray-700

                    [&::-moz-range-track]:w-full
                    [&::-moz-range-track]:h-2
                    [&::-moz-range-track]:bg-gray-100
                    [&::-moz-range-track]:rounded-full"
        onChange={handleInputChanged}
        ref={refInput}
      />
      <span className="text-sm text-gray-500 dark:text-gray-400 absolute start-0 -bottom-6">
        {formatLabel("Min. {value} {unit}", min)}
      </span>
      <span className="text-sm text-gray-500 dark:text-gray-400 absolute end-0 -bottom-6">
        {formatLabel("Max. {value} {unit}", max)}
      </span>
    </div>
  );
};
export default RangeSlider;
